// src/utils/clearCookies.js
import Cookies from 'js-cookie';

export const clearAllCookies = () => {
    // Get all cookies as a single string

    const cookies = document.cookie.split('; ');

    // Loop through the cookies string and remove each one

    cookies.forEach(cookie => {

        const eqPos = cookie.indexOf('=');

        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

        // Remove the cookie with js-cookie
        Cookies.remove(name);

        Cookies.remove(name, { path: '/' });

        // If cookies have other specific paths/domains, you might need to specify those
        // Cookies.remove(name, { path: '/', domain: 'example.com' });
        
    });
};